module.exports = __webpack_public_path__ + "static/newoffice-3900ef40439485a93810d6db5329dfea.jpg";